/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button, useToast } from '@chakra-ui/react';
import { type FunctionComponent } from 'react';
import { copyWithFeedback } from '../../helper';
import { type Request } from '../../interface/Crash';

export const FakeRequestButton: FunctionComponent<{
    request: Request;
    kind: 'crash' | 'protocol';
    reportId: string;
    requestId: number;
}> = ({ kind, reportId, requestId }) => {
    const toast = useToast();

    const fakeUrl = `/report${process.env.REACT_APP_SERVER_FACE_REQUEST_PATH}/${kind}/${reportId}/${requestId}`;

    return (
        <Button
            onClick={() => {
                copyWithFeedback(
                    `self.remote_fake_request("${process.env.REACT_APP_SERVER_URL}${process.env.REACT_APP_SERVER_API_PATH}${fakeUrl}")`,
                    toast,
                );
            }}
        >
            FakeRequest
        </Button>
    );
};
